// 菜单
export default {
    dashboard: '首页',
    flight: '飞行管理',
    department: '部门管理',
    user: '用户',
    userManage: '用户管理',
    userReview: '用户审核',
    role: '角色管理',
    group: '分组管理',
    log: '日志管理',
    taskManage: '任务管理',
    allTasks: '全部任务',
    myTask: '我的任务',
    taskConfig: '任务配置',
    addTaskSpot: "添加点侦察",
    addTaskArea: "添加区域侦察",
    addTaskOrthophoto: "添加正射影像",
    addTaskObliquePhotography: "添加倾斜摄影",
    addTaskLogistics: "添加物流运输",

    editTaskSpot: "编辑点侦察",
    editTaskArea: "编辑区域侦察",
    editTaskOrthophoto: "编辑正射影像",
    editTaskObliquePhotography: "编辑倾斜摄影",
    editTaskLogistics: "编辑物流运输",

    approval: '审批管理',
    autoApproval: '自动审批',
    noFlyZone: '禁飞区管理',
    addNoFlyZone: '添加禁飞区',
    editNoFlyZone: '编辑禁飞区',
    noFlyZoneLifted: '禁飞区解禁申请',
    globalFence: '全局电子围栏',
    boundaryAlarm: '越界告警记录',
    device: '设备管理',
    newsPush: '消息推送',
    corporateInformation: '企业信息',

    // button
    query: '查询',
    add: '添加',
    edit: '编辑',
    delete: '删除',
    personnel: '人员管理',
    freezeRecovery: '冻结/恢复',
    legalize: '认证',
    check: '查看',
    submit: '提交',
    release: '发布',
    revoke: '撤销',
    results: '成果展示',
    report: '生成报告',
    recover: '恢复',
    mapView: '地图查看',
    pass: '通过',
    fail: '不通过',
    automaticApprovalSet: '自动审批设置',
    validInvalid: '有效/无效',
    invalid: '失效',
    details: '详情',
    permission: '权限',
    addNews: '新建消息',
    upload: '上传',
}